<template>
	<el-card id="keyFocusProjectsList">
		<el-form :model="searchForm" ref="searchForm" label-position="top">
			<el-row>
				<el-col :xl="6" :lg="8" :md="12">
					<el-form-item label="Project Number:" prop="projectNumber" class="red-label">
						<el-input clearable v-model="searchForm.projectNumber" placeholder="Please input" />
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12">
					<el-form-item label="Representative Office:" prop="representativeOffice">
						<el-select clearable filterable v-model="searchForm.representativeOffice" placeholder="Please select">
							<el-option v-for="item in representativeOfficeList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12">
					<el-form-item label="Project Name:" prop="projectName">
						<el-input clearable v-model="searchForm.projectName" placeholder="Please input" />
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12">
					<el-form-item label="End User (Customer):" prop="endUser">
						<el-input clearable v-model="searchForm.endUser" placeholder="Please input" />
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12">
					<el-form-item label="Attach Service Included:" prop="attachServiceIncluded">
						<el-select clearable v-model="searchForm.attachServiceIncluded" placeholder="Please select">
							<el-option v-for="item in boolOptions" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12">
					<el-form-item label="3S2S Project:" prop="s3s2sProject" class="red-label">
						<el-select clearable v-model="searchForm.s3s2sProject" placeholder="Please select">
							<el-option v-for="item in boolOptions" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="Business Type:" prop="businessType">
						<el-select clearable v-model="searchForm.businessType" placeholder="Please select">
							<el-option v-for="item in businessTypeList" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="IB Service:" prop="ibService">
						<el-select clearable v-model="searchForm.ibService" placeholder="Please select">
							<el-option v-for="item in boolOptions" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="Industry:" prop="industry">
						<el-select clearable filterable v-model="searchForm.industry" placeholder="Please select">
							<el-option v-for="item in industryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="Sub Industry:" prop="subIndustry">
						<el-select clearable filterable v-model="searchForm.subIndustry" placeholder="Please select">
							<el-option v-for="item in subIndustryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="Hardware Delivery Country:" prop="hardwareDeliveryCountry">
						<el-select clearable filterable v-model="searchForm.hardwareDeliveryCountry" placeholder="Please select">
							<el-option v-for="item in hwDeliveryCountryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="Service Delivery Country:" prop="serviceDeliveryCountry">
						<el-select clearable filterable v-model="searchForm.serviceDeliveryCountry" placeholder="Please select">
							<el-option v-for="item in svcDeliveryCountryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="Maintenance Service SLA:" prop="maintenanceServiceSLA">
						<el-select clearable v-model="searchForm.maintenanceServiceSLA" placeholder="Please select">
							<el-option v-for="item in slaList" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="Tier one Partner:" prop="tierOnePartner">
						<el-select clearable filterable remote :remote-method="handleTier1PartnerSearch" :loading="tier1PartnerLoading" v-model="searchForm.tierOnePartner" placeholder="Please input keyword">
							<el-option v-for="item in tier1PartnerList" :key="item.companyName" :label="item.companyName" :value="item.companyName"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="Salesman(Owner):" prop="salesman">
						<el-input clearable v-model="searchForm.salesman" placeholder="Please input" />
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="White List Account:" prop="whiteListAccount" class="red-label">
						<el-select clearable v-model="searchForm.whiteListAccount" placeholder="Please select">
							<el-option v-for="item in boolOptions" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
					<el-form-item label="Project Level:" prop="projectLevel" class="red-label">
						<el-select clearable v-model="searchForm.projectLevel" placeholder="Please select">
							<el-option v-for="item in projectLevelList" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xl="showMoreSearch ? 18 : 12" :lg="24" :md="showMoreSearch ? 12 : 24" style="padding: 34px 0 0 0px; text-align: right;">
					<el-button type="primary" size="small" @click="changeMoreSearch()">Advanced Filter</el-button>
					<el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
					<el-button size="small" @click="handleReset()">Reset</el-button>
					<el-button type="primary" size="small" @click="handleDownloadTemplate()">Download Template</el-button>
					<el-button type="primary" size="small" @click="handleBatchUpload()">Batch Upload</el-button>
					<el-button size="small" :loading="exportLoading" @click="handleExport()">Export</el-button>
				</el-col>
			</el-row>
		</el-form>
		<el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" @row-dblclick="row => $emit('open-detail', row)">
			<el-table-column prop="id" label="id" v-if="false"></el-table-column>
			<el-table-column prop="projectNumber" label="Project Number" align="left" min-width="147" fixed="left" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<a style="color:blue;cursor:pointer;" @click.stop="$emit('open-detail', scope.row)">{{ scope.row.projectNumber }}</a>
				</template>
			</el-table-column>
			<el-table-column prop="projectName" label="Project Name" align="left" min-width="230" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="representativeOffice" label="Representative Office" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="businessType" label="Business Type" align="center" min-width="115" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.businessType" size="small" type="primary">{{ scope.row.businessType }}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="serviceContractNo" label="Service Contract No." align="center" min-width="160">
				<template slot-scope="scope">
					<el-tooltip placement="top" :disabled="!isServiceContractMultiple(scope.row.serviceContractNo)">
						<div slot="content">
							<div v-for="(item, idx) in getServiceContractItems(scope.row.serviceContractNo)" :key="idx" style="line-height:1.8">{{ item }}</div>
						</div>
						<span class="service-contract-cell">{{ scope.row.serviceContractNo }}</span>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column prop="projectLevel" label="Project Level" align="center" min-width="185" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.projectLevel" size="small" type="warning">{{ scope.row.projectLevel }}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="ibService" label="IB Service" align="center" min-width="90" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-tag size="small" :type="scope.row.ibService ? 'success' : 'danger'">{{ scope.row.ibService ? 'Yes' : 'No' }}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="endUser" label="End User (Customer)" align="left" min-width="160" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="industry" label="Industry" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="hardwareDeliveryCountry" label="Hardware Delivery Country" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="serviceDeliveryCountry" label="Service Delivery Country" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="tierOnePartner" label="Tier one Partner" align="left" min-width="150" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="salesman" label="Salesman(Owner)" align="center" min-width="140" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="projectStatus" label="Project Status" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="operation" label="Operation" align="center" min-width="110" fixed="right">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click.stop="$emit('open-detail', scope.row)">Operation</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pageDiv" v-if="totalCount && totalCount > 0">
			<el-pagination
				small
				layout="total, prev, pager, next, sizes, jumper"
				:page-sizes="[10, 20, 50, 100]"
				:current-page="currentPage"
				:page-size="pageSize"
				:total="totalCount"
				@size-change="changePageSize"
				@current-change="changePage"
			></el-pagination>
		</div>
	</el-card>
</template>

<script>
export default {
	name: 'ProjectList',
	props: {
		searchForm: { type: Object, default: () => ({}) },
		showMoreSearch: { type: Boolean, default: false },
		businessTypeList: { type: Array, default: () => [] },
		projectLevelList: { type: Array, default: () => [] },
		boolOptions: { type: Array, default: () => [] },
		slaList: { type: Array, default: () => [] },
		representativeOfficeList: { type: Array, default: () => [] },
		industryList: { type: Array, default: () => [] },
		subIndustryList: { type: Array, default: () => [] },
		hwDeliveryCountryList: { type: Array, default: () => [] },
		svcDeliveryCountryList: { type: Array, default: () => [] },
		tier1PartnerList: { type: Array, default: () => [] },
		tier1PartnerLoading: { type: Boolean, default: false },
		tableData: { type: Array, default: () => [] },
		tableLoading: { type: Boolean, default: false },
		currentPage: { type: Number, default: 1 },
		pageSize: { type: Number, default: 10 },
		totalCount: { type: Number, default: 0 },
		exportLoading: { type: Boolean, default: false },
	},
	methods: {
		isServiceContractMultiple(val) {
			return val && val.includes(';')
		},
		getServiceContractItems(val) {
			if (!val) return []
			return val.split(';').map(item => item.trim()).filter(item => item)
		},
		handleTier1PartnerSearch(query) {
			this.$emit('search-tier1-partner', query)
		},
		changeMoreSearch() {
			this.$emit('change-more-search')
		},
		handleSearch() {
			this.$emit('search', true)
		},
		handleReset() {
			this.$emit('reset')
		},
		changePageSize(size) {
			this.$emit('change-page-size', size)
		},
		changePage(current) {
			this.$emit('change-page', current)
		},
		handleDownloadTemplate() {
			this.$emit('download-template')
		},
		handleBatchUpload() {
			this.$emit('batch-upload')
		},
		handleExport() {
			this.$emit('export')
		},
	},
}
</script>
<style lang="less" scoped>
#keyFocusProjectsList {
	/deep/.el-table .cell {
		word-break: break-word;
	}
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 0px;
			padding: 0 15px 0 0;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 0px 0px;
		}
		/deep/.red-label .el-form-item__label {
			color: #e73131 !important;
			font-weight: 600;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	.service-contract-cell {
		display: block;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
</style>




// WEBPACK FOOTER //
// src/view/keyFocusProjects/ProjectList.vue